import React from 'react';
import { StatCard } from '../shared';
import { getScoreColor } from '../utils';

interface WidgetScoreProps {
  avgScore: number;
  trend: number;
}

export const WidgetScore: React.FC<WidgetScoreProps> = ({ avgScore, trend }) => (
  <StatCard
    label="Average Score"
    value={avgScore.toFixed(1)}
    color={getScoreColor(avgScore)}
    trend={trend}
  />
);
